import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAudience = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 30,
	viewBox: "0 0 38 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.625 13.125C7.69336 13.125 9.375 11.4434 9.375 9.375C9.375 7.30664 7.69336 5.625 5.625 5.625C3.55664 5.625 1.875 7.30664 1.875 9.375C1.875 11.4434 3.55664 13.125 5.625 13.125ZM31.875 13.125C33.9434 13.125 35.625 11.4434 35.625 9.375C35.625 7.30664 33.9434 5.625 31.875 5.625C29.8066 5.625 28.125 7.30664 28.125 9.375C28.125 11.4434 29.8066 13.125 31.875 13.125ZM33.75 15H30C28.9687 15 28.0371 15.416 27.3574 16.0898C29.7187 17.3848 31.3945 19.7227 31.7578 22.5H35.625C36.6621 22.5 37.5 21.6621 37.5 20.625V18.75C37.5 16.6816 35.8184 15 33.75 15ZM18.75 15C22.377 15 25.3125 12.0645 25.3125 8.4375C25.3125 4.81055 22.377 1.875 18.75 1.875C15.123 1.875 12.1875 4.81055 12.1875 8.4375C12.1875 12.0645 15.123 15 18.75 15ZM23.25 16.875H22.7637C21.5449 17.4609 20.1914 17.8125 18.75 17.8125C17.3086 17.8125 15.9609 17.4609 14.7363 16.875H14.25C10.5234 16.875 7.5 19.8984 7.5 23.625V25.3125C7.5 26.8652 8.75977 28.125 10.3125 28.125H27.1875C28.7402 28.125 30 26.8652 30 25.3125V23.625C30 19.8984 26.9766 16.875 23.25 16.875ZM10.1426 16.0898C9.46289 15.416 8.53125 15 7.5 15H3.75C1.68164 15 0 16.6816 0 18.75V20.625C0 21.6621 0.837891 22.5 1.875 22.5H5.73633C6.10547 19.7227 7.78125 17.3848 10.1426 16.0898Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 37.5,
			height: 30,
			fill: "white"
		})
	}) })]
});
export default SvgIconAudience;
